import React from "react";

import {
	IconCheckCircleOutlined,
	IconCloseCircleOutlined,
	IconExclamationCircleOutlined,
	IconInfoCircleOutlined,
} from "~/components/icon";

import { Api, type SystemNotificationSeverity } from "../../common/openapi";

export const SystemNotificationSeverityIcon = ({
	severity,
}: {
	severity: SystemNotificationSeverity;
}): React.ReactElement => {
	switch (severity) {
		case Api.SystemNotificationSeverity.Problem:
			return <IconCloseCircleOutlined className="text-red-500" />;
		case Api.SystemNotificationSeverity.Warning:
			return <IconExclamationCircleOutlined className="text-orange-500" />;
		case Api.SystemNotificationSeverity.Ok:
			return <IconCheckCircleOutlined className="text-green-500" />;
		case Api.SystemNotificationSeverity.Info:
			return <IconInfoCircleOutlined className="text-blue-500" />;
	}
};
